/* eslint-disable */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output, ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { CheckboxChangeEvent } from './checkbox.interfaces';

export const CHECKBOX_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckboxComponent),
  multi: true
};

@Component({
  selector: 'rx-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [CHECKBOX_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent implements ControlValueAccessor {

  /** A unique id for the checkbox input. */
  @Input() id = 1;

  /** Whether the checkbox is disabled. */
  @Input() disabled: boolean;

  /** Whether the checkbox is required. */
  @Input() required: boolean;

  /** The value attribute of the native input element. */
  @Input() value = 'on';

  /* Optional name used on the input */
  @Input() name: string;

  /** Will be applied as label. */
  @Input() label: string;

  /** Will be applied as secondary label. */
  @Input() secondaryLabel: string;

  @ViewChild('cb') inputViewChild: ElementRef;

  /** Event emitted when the checkbox checked value changes. */
  @Output() change = new EventEmitter<CheckboxChangeEvent>();

  /** Checked state */
    // tslint:disable-next-line:no-any
  model: any;
  checked = false;
  focused = false;

  onModelChange: Function = () => {};
  onModelTouched: Function = () => {};

  constructor(private cd: ChangeDetectorRef) {}

  updateModel(event) {
    this.onModelChange(this.checked);

    this.change.emit({ event, checked: this.checked, value: this.value});
  }

  /** On checked state change */
  // tslint:disable-next-line:no-any
  handleChange(event) {
    if (!this.disabled) {
      this.checked = event.target.checked;
      this.updateModel(event);
    }
  }

  onClick(event, checkbox, focus: boolean) {
    event.preventDefault();

    if (this.disabled) {
      return;
    }

    this.checked = !this.checked;
    this.updateModel(event);

    if (focus) {
      checkbox.focus();
    }
  }

  // tslint:disable-next-line:no-any
  writeValue(model: any): void {
    this.model = this.checked = model;
    this.cd.markForCheck();
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  onFocus() {
    this.focused = true;
  }

  onBlur() {
    this.focused = false;
    this.onModelTouched();
  }
}
